import { render, staticRenderFns } from "./OptionsTextAdd.vue?vue&type=template&id=8229f108&"
import script from "./OptionsTextAdd.vue?vue&type=script&lang=js&"
export * from "./OptionsTextAdd.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTextAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports